import React, { useState, useEffect } from 'react';
import { Video, Mic, MonitorPlay, Zap, Check, X, Shield, LockOpen, Chrome, Download, Camera, ArrowLeft, Sun, Lock, UserCheck, Home } from 'lucide-react';

// Dicionário de Traduções e Textos Legais
const translations = {
    pt: {
        nav_features: "Recursos",
        nav_pricing: "Preço",
        nav_faq: "FAQ",
        badge: "O fim do modelo de assinaturas",
        title_1: "Grave a sua tela.",
        title_2: "Não a sua carteira.",
        subtitle: "Cansado de pagar $15/mês por gravadores limitados? O OneBuck Recorder é a extensão definitiva: grave em WEBM/MP4, salve localmente ou no Google Drive de graça. O Premium? Custa apenas $1. Para sempre.",
        btn_free: "Instalar no Chrome",
        btn_pro: "Ver Upgrade ($1)",
        platform: "Extensão oficial para Google Chrome e Edge.",

        // Preview Mockup
        preview_free: "GRÁTIS",
        preview_limit: "Limite: 5:00",
        preview_quality: "Qualidade",
        preview_mic: "Microfone",
        preview_webcam: "Webcam overlay",
        preview_record: "Iniciar Gravação",
        preview_login: "Entrar",
        preview_upgrade: "Upgrade Starter ($1)",
        preview_version: "OneBuck Recorder v1.0.0",

        // Agitation & Features
        agitation_title: "A indústria de SaaS perdeu o juízo.",
        agitation_desc: "Pagar uma assinatura mensal só para gravar uma aba do seu navegador não faz sentido. O processamento é local. Não vamos cobrar pelo que a sua máquina já faz.",
        feat1_title: "Exportação Universal",
        feat1_desc: "Gere arquivos WEBM ou MP4 de alta qualidade instantaneamente. Sem esperas de renderização na nuvem.",
        feat2_title: "Google Drive Sync",
        feat2_desc: "Faça login com a sua conta Google e salve os vídeos diretamente no seu Drive. Compartilhe os links em segundos.",
        feat3_title: "Starter Plan ($1)",
        feat3_desc: "Acabe com o limite de 5 minutos, desbloqueie a gravação em 1080p nativo e remova qualquer limitação visual.",

        // Pricing
        pricing_title: "Nossa promessa anti-mensalidade.",
        pricing_desc: "Tudo o que você precisa de graça. O Premium mais acessível do planeta para os power-users.",
        price_free_desc: "Para o dia a dia.",
        price_free_1: "Resolução 720p",
        price_free_2: "Limite de 5 minutos",
        price_free_3: "Exportação WEBM / MP4",
        price_free_4: "Upload p/ Google Drive",
        btn_download: "Instalar Grátis",

        price_pro_badge: "Pagamento Único",
        price_pro_title: "Starter Plan",
        price_pro_period: " / vitalício",
        price_pro_desc: "Desbloqueie o poder total da sua extensão.",
        price_pro_1: "Resolução 1080p e 4K",
        price_pro_2: "Tempo ilimitado de gravação",
        price_pro_3: "Qualidade de áudio superior",
        price_pro_4: "Atualizações gratuitas garantidas",
        btn_unlock: "Desbloquear por $1",

        footer_rights: "Todos os direitos reservados.",
        footer_terms: "Termos",
        footer_privacy: "Privacidade",
        footer_email: "onebuckrecorder@gmail.com",

        // Success Page
        success_title: "Pagamento Confirmado! 🚀",
        success_subtitle: "Bem-vindo ao Starter Plan. Você acaba de se libertar das assinaturas.",
        success_step1_title: "1. Pagamento Vinculado",
        success_step1_desc: "O seu e-mail foi automaticamente vinculado ao plano Starter. Sem chaves, sem complicação.",
        success_step2_title: "2. Abra a Extensão",
        success_step2_desc: "Clique no ícone do OneBuck Recorder no topo do seu navegador.",
        success_step3_title: "3. Tudo Pronto",
        success_step3_desc: "O aplicativo já deve reconhecer o seu upgrade. Os limites foram removidos para sempre.",
        btn_back_home: "Voltar ao Início",

        // Legal - Privacy
        privacy_title: "Política de Privacidade",
        privacy_content: [
            { h: "Data de Vigência: 6 de Março de 2026", p: "No OneBuck Recorder, levamos a sua privacidade a sério. Esta política explica como lidamos com seus dados, garantindo transparência e segurança enquanto você usa nossa extensão de gravação de tela." },
            { h: "1. Coleta e Uso de Informações", p: "Operamos sob o princípio da Minimização de Dados.\n\n• Dados Pessoais: Não exigimos uma conta tradicional. Se você usar a integração com o Google Drive, podemos acessar seu endereço de e-mail do Google exclusivamente para fins de autenticação via Google Identity API.\n• Dados de Gravação: Não coletamos, armazenamos ou temos acesso às suas gravações de vídeo ou áudio. Toda a gravação e processamento ocorrem localmente na sua máquina." },
            { h: "2. Justificativa de Permissões", p: "Para funcionar corretamente, o OneBuck Recorder exige as seguintes permissões do navegador:\n\n• Armazenamento (Storage): Para salvar suas preferências de gravação (ex: resolução, atalhos).\n• Captura de Tela/Aba: Para gravar o conteúdo da sua tela ou abas do navegador.\n• Microfone/Câmera: Para incluir sua voz e imagem da webcam nas gravações.\n• Google Drive API: Para permitir que você faça upload dos seus vídeos finalizados diretamente para o seu armazenamento pessoal na nuvem." },
            { h: "3. Retenção e Compartilhamento de Dados", p: "Nós não vendemos, alugamos ou compartilhamos suas informações pessoais ou e-mail com terceiros.\n\n• Processamento Local: Todo o processamento de vídeo ocorre localmente no seu dispositivo; suas gravações nunca são enviadas para os nossos servidores.\n• Integração com Google Drive: Se você optar por salvar as gravações no Google Drive, os dados são transferidos diretamente do seu navegador para a sua nuvem pessoal. Não armazenamos, visualizamos ou temos a capacidade de recuperar seu conteúdo gravado.\n• Sem Analytics de Terceiros: Não usamos rastreamento invasivo ou analytics de terceiros que monitorem seu histórico de gravações ou comportamento de navegação." },
            { h: "4. Segurança", p: "Como suas gravações nunca saem do seu dispositivo (a menos que você faça o upload manual para o seu Drive), a segurança do seu conteúdo está ligada à segurança do seu sistema local. Usamos protocolos OAuth2 padrão da indústria para autenticação do Google Drive para garantir que seu acesso à nuvem permaneça privado e seguro." },
            { h: "5. Seus Direitos", p: "Você tem o direito de parar de usar a extensão e revocar o acesso ao seu Google Drive a qualquer momento através das configurações de segurança da sua Conta do Google. Como não armazenamos seus vídeos, não há dados em nossos servidores para você 'excluir'." },
            { h: "6. Alterações nesta Política", p: "Podemos atualizar esta Política de Privacidade de tempos em tempos. Quaisquer alterações serão refletidas pela data no topo desta página." },
            { h: "7. Fale Conosco", p: "Se você tiver alguma dúvida sobre esta Política de Privacidade, entre em contato conosco em:\nonebuckrecorder@gmail.com" }
        ],

        // Legal - Terms
        terms_title: "Termos de Serviço",
        terms_content: [
            { h: "1. Aceitação dos Termos", p: "Ao instalar e utilizar a extensão OneBuck Recorder, você concorda com estes Termos de Serviço. O uso da ferramenta é por sua conta e risco." },
            { h: "2. Licença Vitalícia (Lifetime License)", p: "A compra do 'Starter Plan' por $1 concede uma licença de uso vitalícia vinculada à sua conta. Para efeitos legais, 'vitalícia' refere-se à vida útil do produto (OneBuck Recorder) e não à vida do usuário. Reservamo-nos o direito de descontinuar o produto no futuro (ex: devido a mudanças drásticas no ecossistema de extensões do Google Chrome). Garantimos o suporte e atualizações enquanto o produto for mantido ativamente." },
            { h: "3. Responsabilidade de Conteúdo", p: "Como a ferramenta opera 100% localmente no seu computador, você é o único e exclusivo responsável por todo o conteúdo gravado, processado ou enviado ao Google Drive através do OneBuck Recorder. Você concorda em não usar a ferramenta para gravar informações confidenciais de terceiros sem autorização, contornar DRM ou infringir direitos autorais." },
            { h: "4. Política de Reembolso e Isenção de Garantias", p: "Devido ao valor simbólico ($1) e à natureza digital de ativação imediata na conta, todas as vendas são finais e não oferecemos reembolsos. O software é fornecido 'tal como está', sem garantias expressas ou implícitas de funcionamento em todas as futuras versões de navegadores." }
        ]
    },
    en: {
        nav_features: "Features",
        nav_pricing: "Pricing",
        nav_faq: "FAQ",
        badge: "The end of subscriptions",
        title_1: "Record your screen.",
        title_2: "Not your wallet.",
        subtitle: "Tired of paying $15/mo for limited screen recorders? OneBuck Recorder is the ultimate extension: record in WEBM/MP4, save locally or to Google Drive for free. Premium? It's just $1. Forever.",
        btn_free: "Add to Chrome",
        btn_pro: "View Upgrade ($1)",
        platform: "Official extension for Google Chrome and Edge.",

        // Preview Mockup
        preview_free: "FREE",
        preview_limit: "Limit: 5:00",
        preview_quality: "Quality",
        preview_mic: "Microphone",
        preview_webcam: "Webcam overlay",
        preview_record: "Start Recording",
        preview_login: "Login",
        preview_upgrade: "Upgrade Starter ($1)",
        preview_version: "OneBuck Recorder v1.0.0",

        // Agitation & Features
        agitation_title: "The SaaS industry went crazy.",
        agitation_desc: "Paying a monthly subscription just to record your browser tab makes no sense. The processing is local. We won't charge you for what your machine already does.",
        feat1_title: "Universal Export",
        feat1_desc: "Generate high-quality WEBM or MP4 files instantly. No waiting for cloud rendering.",
        feat2_title: "Google Drive Sync",
        feat2_desc: "Login with your Google account and save videos directly to your Drive. Share links in seconds.",
        feat3_title: "Starter Plan ($1)",
        feat3_desc: "Drop the 5-minute limit, unlock native 1080p recording, and remove all visual limitations.",

        // Pricing
        pricing_title: "Our anti-subscription promise.",
        pricing_desc: "Everything you need for free. The most affordable Premium on the planet for power-users.",
        price_free_desc: "For daily tasks.",
        price_free_1: "720p Resolution",
        price_free_2: "5-minute limit",
        price_free_3: "WEBM / MP4 Export",
        price_free_4: "Upload to Google Drive",
        btn_download: "Install for Free",

        price_pro_badge: "One-Time Payment",
        price_pro_title: "Starter Plan",
        price_pro_period: " / lifetime",
        price_pro_desc: "Unlock the full power of your extension.",
        price_pro_1: "1080p & 4K Resolution",
        price_pro_2: "Unlimited recording time",
        price_pro_3: "Superior audio quality",
        price_pro_4: "Guaranteed free updates",
        btn_unlock: "Unlock for $1",

        footer_rights: "All rights reserved.",
        footer_terms: "Terms",
        footer_privacy: "Privacy",
        footer_email: "onebuckrecorder@gmail.com",

        // Success Page
        success_title: "Payment Confirmed! 🚀",
        success_subtitle: "Welcome to the Starter Plan. You just broke free from subscriptions.",
        success_step1_title: "1. Account Linked",
        success_step1_desc: "Your email has been automatically linked to the Starter plan. No keys, no hassle.",
        success_step2_title: "2. Open the Extension",
        success_step2_desc: "Click the OneBuck Recorder icon at the top of your browser.",
        success_step3_title: "3. Ready to Go",
        success_step3_desc: "The app should already recognize your upgrade. Limits removed forever.",
        btn_back_home: "Back to Home",

        // Legal - Privacy
        privacy_title: "Privacy Policy",
        privacy_content: [
            { h: "Effective Date: March 6, 2026", p: "At OneBuck Recorder, we take your privacy seriously. This policy explains how we handle your data, ensuring transparency and security while you use our screen recording extension." },
            { h: "1. Information Collection and Use", p: "We operate on a principle of Data Minimization.\n\n• Personal Data: We do not require a traditional account. If you use the Google Drive integration, we may access your Google email address solely for authentication purposes via the Google Identity API.\n• Recording Data: We do not collect, store, or have access to your video or audio recordings. All recording and processing happen locally on your machine." },
            { h: "2. Permissions Justification", p: "To function correctly, OneBuck Recorder requires the following permissions:\n\n• Storage: To save your recording preferences (e.g., resolution, shortcuts).\n• Tab/Screen Capture: To record the contents of your screen or browser tabs.\n• Microphone/Camera: To include your voice and webcam overlay in the recordings.\n• Google Drive API: To allow you to upload your finished videos directly to your personal cloud storage." },
            { h: "3. Data Retention and Sharing", p: "We do not sell, rent, or share your personal information or email address with third parties.\n\n• Local Processing: All video processing occurs locally on your device; your recordings are never uploaded to our servers.\n• Google Drive Integration: If you choose to save recordings to Google Drive, the data is transferred directly from your browser to your personal cloud storage. We do not store, view, or have the ability to retrieve your recorded content.\n• No Third-Party Analytics: We do not use invasive tracking or third-party analytics that monitor your recording history or browsing behavior." },
            { h: "4. Security", p: "Since your recordings never leave your device (unless you manually upload them to your Drive), the security of your content is tied to your local system's security. We use industry-standard OAuth2 protocols for Google Drive authentication to ensure your cloud access remains private and secure." },
            { h: "5. Your Rights", p: "You have the right to stop using the extension and revoke access to your Google Drive at any time through your Google Account settings. Since we do not store your videos, there is no data on our servers for you to 'delete.'" },
            { h: "6. Changes to This Policy", p: "We may update this Privacy Policy from time to time. Any changes will be reflected by the 'Last Updated' date at the top of this page." },
            { h: "7. Contact Us", p: "If you have any questions about this Privacy Policy, please contact us at:\nonebuckrecorder@gmail.com" }
        ],

        // Legal - Terms
        terms_title: "Terms of Service",
        terms_content: [
            { h: "1. Acceptance of Terms", p: "By installing and using the OneBuck Recorder extension, you agree to these Terms of Service. Use of the tool is at your own risk." },
            { h: "2. Lifetime License", p: "Purchasing the 'Starter Plan' for $1 grants a lifetime license linked to your account. For legal purposes, 'lifetime' refers to the lifecycle of the product (OneBuck Recorder) and not the life of the user. We reserve the right to discontinue the product in the future (e.g., due to drastic changes in the Google Chrome extension ecosystem). We guarantee support and updates as long as the product is actively maintained." },
            { h: "3. Content Responsibility", p: "Because the tool operates 100% locally on your computer, you are solely and exclusively responsible for all content recorded, processed, or uploaded to Google Drive via OneBuck Recorder. You agree not to use the tool to record confidential third-party information without authorization, bypass DRM, or infringe copyrights." },
            { h: "4. Refund Policy and Disclaimer of Warranties", p: "Due to the nominal value ($1) and the digital nature of immediate account activation, all sales are final and we do not offer refunds. The software is provided 'as is', without express or implied warranties that it will function in all future browser versions." }
        ]
    },
    es: {
        nav_features: "Funciones",
        nav_pricing: "Precios",
        nav_faq: "FAQ",
        badge: "El fin de las suscripciones",
        title_1: "Graba tu pantalla.",
        title_2: "No tu billetera.",
        subtitle: "¿Cansado de pagar $15/mes por grabadores limitados? OneBuck Recorder es la extensión definitiva: graba en WEBM/MP4, guarda localmente o en Google Drive gratis. ¿El Premium? Cuesta solo $1. Para siempre.",
        btn_free: "Instalar en Chrome",
        btn_pro: "Ver Upgrade ($1)",
        platform: "Extensión oficial para Google Chrome y Edge.",

        // Preview Mockup
        preview_free: "GRATIS",
        preview_limit: "Límite: 5:00",
        preview_quality: "Calidad",
        preview_mic: "Micrófono",
        preview_webcam: "Webcam overlay",
        preview_record: "Iniciar Grabación",
        preview_login: "Entrar",
        preview_upgrade: "Upgrade Starter ($1)",
        preview_version: "OneBuck Recorder v1.0.0",

        // Agitation & Features
        agitation_title: "La industria SaaS se volvió loca.",
        agitation_desc: "Pagar una suscripción mensual solo por grabar una pestaña de tu navegador no tiene sentido. El procesamiento es local. No te cobraremos por lo que tu máquina ya hace.",
        feat1_title: "Exportación Universal",
        feat1_desc: "Genera archivos WEBM o MP4 de alta calidad al instante. Sin esperas de renderizado en la nube.",
        feat2_title: "Google Drive Sync",
        feat2_desc: "Inicia sesión con tu cuenta de Google y guarda los videos directamente en tu Drive. Comparte enlaces en segundos.",
        feat3_title: "Starter Plan ($1)",
        feat3_desc: "Elimina el límite de 5 minutos, desbloquea la grabación en 1080p nativo y elimina cualquier limitación.",

        // Pricing
        pricing_title: "Nuestra promesa anti-suscripción.",
        pricing_desc: "Todo lo que necesitas gratis. El Premium más accesible del planeta para power-users.",
        price_free_desc: "Para el día a día.",
        price_free_1: "Resolución 720p",
        price_free_2: "Límite de 5 minutos",
        price_free_3: "Exportación WEBM / MP4",
        price_free_4: "Subida a Google Drive",
        btn_download: "Instalar Gratis",

        price_pro_badge: "Pago Único",
        price_pro_title: "Starter Plan",
        price_pro_period: " / de por vida",
        price_pro_desc: "Desbloquea el poder total de tu extensión.",
        price_pro_1: "Resolución 1080p y 4K",
        price_pro_2: "Tiempo de grabación ilimitado",
        price_pro_3: "Calidad de audio superior",
        price_pro_4: "Actualizaciones gratuitas garantizadas",
        btn_unlock: "Desbloquear por $1",

        footer_rights: "Todos los derechos reservados.",
        footer_terms: "Términos",
        footer_privacy: "Privacidad",
        footer_email: "onebuckrecorder@gmail.com",

        // Success Page
        success_title: "¡Pago Confirmado! 🚀",
        success_subtitle: "Bienvenido al Starter Plan. Te acabas de liberar de las suscripciones.",
        success_step1_title: "1. Pago Vinculado",
        success_step1_desc: "Tu correo ha sido vinculado automáticamente al plan Starter. Sin claves, sin complicaciones.",
        success_step2_title: "2. Abre la Extensión",
        success_step2_desc: "Haz clic en el ícono de OneBuck Recorder en la parte superior de tu navegador.",
        success_step3_title: "3. Todo Listo",
        success_step3_desc: "La aplicación ya debería reconocer tu actualización. Límites eliminados para siempre.",
        btn_back_home: "Volver al Inicio",

        // Legal - Privacy
        privacy_title: "Política de Privacidad",
        privacy_content: [
            { h: "Fecha de Entrada en Vigor: 6 de Marzo de 2026", p: "En OneBuck Recorder, nos tomamos muy en serio tu privacidad. Esta política explica cómo manejamos tus datos, garantizando transparencia y seguridad mientras usas nuestra extensión de grabación de pantalla." },
            { h: "1. Recopilación y Uso de Información", p: "Operamos bajo el principio de Minimización de Datos.\n\n• Datos Personales: No requerimos una cuenta tradicional. Si usas la integración con Google Drive, podemos acceder a tu correo electrónico de Google únicamente para fines de autenticación a través de la API de Google Identity.\n• Datos de Grabación: No recopilamos, almacenamos ni tenemos acceso a tus grabaciones de video o audio. Toda la grabación y el procesamiento ocurren localmente en tu máquina." },
            { h: "2. Justificación de Permisos", p: "Para funcionar correctamente, OneBuck Recorder requiere los siguientes permisos:\n\n• Almacenamiento (Storage): Para guardar tus preferencias de grabación (ej. resolución, atajos).\n• Captura de Pestaña/Pantalla: Para grabar el contenido de tu pantalla o pestañas del navegador.\n• Micrófono/Cámara: Para incluir tu voz y la superposición de tu cámara web en las grabaciones.\n• API de Google Drive: Para permitirte subir tus videos terminados directamente a tu almacenamiento personal en la nube." },
            { h: "3. Retención y Uso Compartido de Datos", p: "No vendemos, alquilamos ni compartimos tu información personal o correo electrónico con terceros.\n\n• Procesamiento Local: Todo el procesamiento de video ocurre localmente en tu dispositivo; tus grabaciones nunca se suben a nuestros servidores.\n• Integración con Google Drive: Si eliges guardar grabaciones en Google Drive, los datos se transfieren directamente desde tu navegador a tu nube personal. No almacenamos, vemos ni tenemos la capacidad de recuperar tu contenido grabado.\n• Sin Analíticas de Terceros: No utilizamos rastreo invasivo ni analíticas de terceros que monitoreen tu historial de grabaciones o comportamiento de navegación." },
            { h: "4. Seguridad", p: "Dado que tus grabaciones nunca salen de tu dispositivo (a menos que las subas manualmente a tu Drive), la seguridad de tu contenido está ligada a la seguridad de tu sistema local. Utilizamos protocolos OAuth2 estándar de la industria para la autenticación de Google Drive para asegurar que tu acceso a la nube permanezca privado y seguro." },
            { h: "5. Tus Derechos", p: "Tienes derecho a dejar de usar la extensión y revocar el acceso a tu Google Drive en cualquier momento a través de la configuración de seguridad de tu Cuenta de Google. Como no almacenamos tus videos, no hay datos en nuestros servidores que puedas 'eliminar'." },
            { h: "6. Cambios en esta Política", p: "Podemos actualizar esta Política de Privacidad ocasionalmente. Cualquier cambio se reflejará en la fecha en la parte superior de esta página." },
            { h: "7. Contáctanos", p: "Si tienes alguna pregunta sobre esta Política de Privacidad, por favor contáctanos en:\nonebuckrecorder@gmail.com" }
        ],

        // Legal - Terms
        terms_title: "Términos de Servicio",
        terms_content: [
            { h: "1. Aceptación", p: "Al usar OneBuck Recorder, aceptas estos términos. El uso es bajo tu propio riesgo." },
            { h: "2. Licencia de por vida", p: "El 'Starter Plan' de $1 otorga una licencia vinculada a tu cuenta por la vida útil del producto, no del usuario. Nos reservamos el derecho de discontinuar el producto en el futuro." },
            { h: "3. Responsabilidad", p: "Eres el único responsable del contenido grabado. No uses la herramienta para infringir derechos de autor." },
            { h: "4. Reembolsos", p: "Debido al valor simbólico ($1) y la naturaleza digital de la activación inmediata, todas las ventas son finales y no ofrecemos reembolsos." }
        ]
    }
};

const OneBuckLanding = () => {
    const [lang, setLang] = useState('en');
    const [currentView, setCurrentView] = useState('home');

    // Executa uma vez no carregamento para checar o idioma E o caminho da URL
    useEffect(() => {
        // 1. Deteção de Idioma
        const browserLang = navigator.language || navigator.userLanguage;
        const lowerLang = browserLang.toLowerCase();
        if (lowerLang.includes('pt')) setLang('pt');
        else if (lowerLang.includes('es')) setLang('es');
        else setLang('en');

        // 2. Deteção de Rota (URL Path)
        const path = window.location.pathname;
        if (path.includes('/privacy')) setCurrentView('privacy');
        else if (path.includes('/terms')) setCurrentView('terms');
        else if (path.includes('/success')) setCurrentView('success');
        else setCurrentView('home');

    }, []);

    // Rola para o topo ao mudar de visualização via React state (fallback)
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [currentView]);

    const t = translations[lang];

    // COMPONENTES DE VIZUALIZAÇÃO
    const LegalView = ({ title, content }) => (
        <div className="container mx-auto px-6 py-24 max-w-3xl animate-fade-in-up">
            <a
                href="/"
                className="inline-flex items-center gap-2 text-gray-400 hover:text-white mb-10 transition-colors"
            >
                <ArrowLeft size={16} /> {t.btn_back_home}
            </a>
            <h1 className="text-4xl font-extrabold text-white mb-12">{title}</h1>
            <div className="space-y-10">
                {content.map((section, idx) => (
                    <div key={idx} className="bg-[#151518] p-8 rounded-2xl border border-gray-800/50">
                        <h2 className="text-xl font-bold text-white mb-4">{section.h}</h2>
                        <p className="text-gray-400 leading-relaxed whitespace-pre-line">{section.p}</p>
                    </div>
                ))}
            </div>
        </div>
    );

    const SuccessView = () => (
        <div className="container mx-auto px-6 py-24 max-w-4xl animate-fade-in-up text-center">
            <div className="w-20 h-20 bg-green-500/10 text-green-500 rounded-full flex items-center justify-center mx-auto mb-8 shadow-[0_0_30px_rgba(34,197,94,0.2)]">
                <Check size={40} strokeWidth={3} />
            </div>
            <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-4">{t.success_title}</h1>
            <p className="text-xl text-gray-400 mb-16">{t.success_subtitle}</p>

            <div className="grid md:grid-cols-3 gap-6 text-left mb-16">
                <div className="p-8 bg-[#151518] rounded-2xl border border-gray-800 relative">
                    <div className="absolute -top-4 -left-4 w-10 h-10 bg-[#8b1a1a] text-white font-black flex items-center justify-center rounded-xl shadow-lg shadow-[#8b1a1a]/30">1</div>
                    <UserCheck className="text-[#8b1a1a] mb-4" size={28} />
                    <h3 className="text-white font-bold text-lg mb-2">{t.success_step1_title}</h3>
                    <p className="text-sm text-gray-400">{t.success_step1_desc}</p>
                </div>
                <div className="p-8 bg-[#151518] rounded-2xl border border-gray-800 relative">
                    <div className="absolute -top-4 -left-4 w-10 h-10 bg-[#8b1a1a] text-white font-black flex items-center justify-center rounded-xl shadow-lg shadow-[#8b1a1a]/30">2</div>
                    <Chrome className="text-[#8b1a1a] mb-4" size={28} />
                    <h3 className="text-white font-bold text-lg mb-2">{t.success_step2_title}</h3>
                    <p className="text-sm text-gray-400">{t.success_step2_desc}</p>
                </div>
                <div className="p-8 bg-[#151518] rounded-2xl border border-yellow-600/30 relative">
                    <div className="absolute -top-4 -left-4 w-10 h-10 bg-yellow-500 text-black font-black flex items-center justify-center rounded-xl shadow-lg shadow-yellow-500/30">3</div>
                    <LockOpen className="text-yellow-500 mb-4" size={28} />
                    <h3 className="text-yellow-500 font-bold text-lg mb-2">{t.success_step3_title}</h3>
                    <p className="text-sm text-gray-400">{t.success_step3_desc}</p>
                </div>
            </div>

            <a href="/" className="inline-flex items-center justify-center gap-2 bg-[#1f1f22] hover:bg-[#27272a] text-white border border-gray-800 px-8 py-4 rounded-xl font-bold transition-all">
                <Home size={18} /> {t.btn_back_home}
            </a>
        </div>
    );

    return (
        <div className="min-h-screen bg-[#0f0f11] text-gray-200 font-sans selection:bg-red-500 selection:text-white overflow-x-hidden">

            {/* GLOBAL STYLES & ANIMATIONS */}
            <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes scaleIn {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }
        @keyframes float {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
          100% { transform: translateY(0px); }
        }
        .animate-fade-in-up {
          animation: fadeInUp 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
          opacity: 0;
        }
        .animate-scale-in {
          animation: scaleIn 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
          opacity: 0;
        }
        .animate-float {
          animation: float 6s ease-in-out infinite;
        }
        .delay-100 { animation-delay: 100ms; }
        .delay-200 { animation-delay: 200ms; }
        .delay-300 { animation-delay: 300ms; }
        .delay-400 { animation-delay: 400ms; }
      `}</style>

            {/* NAVBAR */}
            <nav className="container mx-auto px-6 py-4 flex justify-between items-center border-b border-gray-800 relative z-50">
                <a href="/" className="flex items-center gap-3 cursor-pointer">
                    <div className="w-8 h-8 bg-[#8b1a1a] rounded-[10px] flex items-center justify-center shadow-lg shadow-[#8b1a1a]/30">
                        <div className="w-2.5 h-2.5 bg-white rounded-full"></div>
                    </div>
                    <span className="font-bold text-xl text-white tracking-tight">OneBuck Recorder</span>
                </a>

                {currentView === 'home' ? (
                    <div className="hidden md:flex gap-6 text-sm font-medium text-gray-400">
                        <a href="#features" className="hover:text-white transition-colors">{t.nav_features}</a>
                        <a href="#pricing" className="hover:text-white transition-colors">{t.nav_pricing}</a>
                    </div>
                ) : (
                    <div className="hidden md:flex gap-6 text-sm font-medium text-gray-400">
                        <span className="text-gray-600">
                            {currentView === 'success' ? 'Success' : 'Legal Documents'}
                        </span>
                    </div>
                )}

                <select
                    value={lang}
                    onChange={(e) => setLang(e.target.value)}
                    className="text-xs font-bold text-gray-300 hover:text-white uppercase tracking-wider bg-gray-900 px-3 py-1.5 rounded-md border border-gray-800 outline-none cursor-pointer"
                >
                    <option value="en">EN</option>
                    <option value="pt">PT</option>
                    <option value="es">ES</option>
                </select>
            </nav>

            {/* MAIN CONTENT RENDERING */}
            {currentView === 'home' && (
                <>
                    {/* HERO SECTION */}
                    <header className="container mx-auto px-6 py-20 text-center max-w-4xl flex flex-col items-center">
                        <div className="animate-fade-in-up inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-red-500/10 text-red-400 text-xs font-bold uppercase tracking-wider mb-6 border border-red-500/20 shadow-[0_0_15px_rgba(239,68,68,0.1)]">
                            <Zap size={14} /> {t.badge}
                        </div>
                        <h1 className="animate-fade-in-up delay-100 text-5xl md:text-7xl font-extrabold text-white tracking-tight leading-tight mb-8">
                            {t.title_1}<br />
                            <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-orange-400">
                                {t.title_2}
                            </span>
                        </h1>
                        <p className="animate-fade-in-up delay-200 text-lg md:text-xl text-gray-400 mb-10 max-w-3xl leading-relaxed">
                            {t.subtitle}
                        </p>

                        <div className="animate-fade-in-up delay-300 flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
                            <button className="bg-[#ef4444] hover:bg-red-600 text-white px-8 py-4 rounded-xl font-bold text-lg flex items-center justify-center gap-2 transition-transform hover:scale-105 shadow-[0_0_20px_rgba(239,68,68,0.3)]">
                                <Chrome size={20} /> {t.btn_free}
                            </button>
                            <a href="#pricing" className="bg-[#1a1500] hover:bg-[#2a2200] text-yellow-500 border border-yellow-600/50 px-8 py-4 rounded-xl font-bold text-lg flex items-center justify-center gap-2 transition-all hover:scale-105">
                                <LockOpen size={20} /> {t.btn_pro}
                            </a>
                        </div>
                        <p className="animate-fade-in-up delay-400 mt-6 text-sm text-gray-500 flex items-center justify-center gap-2">
                            <Shield size={14} /> {t.platform}
                        </p>
                    </header>

                    {/* APP PREVIEW (MOCKUP ATUALIZADO) */}
                    <section className="container mx-auto px-6 py-12 flex justify-center animate-scale-in delay-300">
                        <div className="w-full max-w-[340px] bg-[#0f0f11] rounded-[24px] border border-gray-800 shadow-[0_0_50px_rgba(0,0,0,0.5)] overflow-hidden relative animate-float p-5">

                            {/* Top Bar Mockup */}
                            <div className="flex justify-between items-start mb-6">
                                <div className="flex items-center gap-3">
                                    <div className="w-9 h-9 bg-[#8b1a1a] rounded-[10px] flex items-center justify-center shadow-[0_0_10px_rgba(139,26,26,0.4)]">
                                        <div className="w-2.5 h-2.5 bg-white rounded-full"></div>
                                    </div>
                                    <div className="flex flex-col">
                                        <h3 className="text-white text-[15px] font-bold leading-tight tracking-tight">OneBuck Recorder</h3>
                                        <span className="text-[#6b7280] text-[10px] font-bold tracking-widest">{t.preview_free}</span>
                                    </div>
                                </div>
                                <div className="w-8 h-8 rounded-lg border border-gray-800 flex items-center justify-center text-gray-400 bg-[#121214]">
                                    <Sun size={16} />
                                </div>
                            </div>

                            {/* Timer */}
                            <div className="text-center mb-6">
                                <div className="text-[64px] font-black text-[#52525b] tracking-wider leading-none mb-1 font-mono">00:00</div>
                                <div className="text-xs text-gray-500 font-medium">{t.preview_limit}</div>
                            </div>

                            {/* Controls List Box */}
                            <div className="bg-[#161618] border border-gray-800/60 rounded-2xl flex flex-col mb-4">

                                {/* Quality Row */}
                                <div className="flex justify-between items-center p-4 border-b border-gray-800/60">
                                    <div className="flex items-center gap-3 text-[13px] font-medium text-gray-400">
                                        <MonitorPlay size={16} className="text-gray-500" /> {t.preview_quality}
                                    </div>
                                    <div className="flex bg-[#09090b] rounded-lg p-1 border border-gray-800/80">
                                        <button className="px-2.5 py-1 bg-[#27272a] text-white rounded-md text-[11px] font-bold shadow-sm">720p</button>
                                        <button className="px-2.5 py-1 text-gray-500 text-[11px] font-bold flex items-center gap-1 cursor-not-allowed">1080p <Lock size={10} className="text-[#d97706]" /></button>
                                        <button className="px-2.5 py-1 text-gray-500 text-[11px] font-bold flex items-center gap-1 cursor-not-allowed">4K <Lock size={10} className="text-[#d97706]" /></button>
                                    </div>
                                </div>

                                {/* Mic Row */}
                                <div className="flex justify-between items-center p-4 border-b border-gray-800/60">
                                    <div className="flex items-center gap-3 text-[13px] font-medium text-gray-400">
                                        <Mic size={16} className="text-gray-500" /> {t.preview_mic}
                                    </div>
                                    {/* Toggle ON */}
                                    <div className="w-10 h-6 bg-[#22c55e] rounded-full relative cursor-pointer">
                                        <div className="absolute right-1 top-1 w-4 h-4 bg-white rounded-full shadow-sm"></div>
                                    </div>
                                </div>

                                {/* Webcam Row */}
                                <div className="flex justify-between items-center p-4">
                                    <div className="flex items-center gap-3 text-[13px] font-medium text-gray-400">
                                        <Camera size={16} className="text-gray-500" /> {t.preview_webcam}
                                    </div>
                                    {/* Toggle OFF */}
                                    <div className="w-10 h-6 bg-gray-700 rounded-full relative cursor-pointer shadow-inner">
                                        <div className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full shadow-sm"></div>
                                    </div>
                                </div>

                            </div>

                            {/* Action Buttons */}
                            <div className="flex flex-col gap-3">
                                <button className="w-full bg-[#ef4444] hover:bg-red-600 text-white font-bold py-3.5 rounded-xl flex items-center justify-center gap-2 text-[14px] shadow-[0_4px_14px_rgba(239,68,68,0.2)] transition-all">
                                    <div className="w-2 h-2 bg-white rounded-full"></div> {t.preview_record}
                                </button>

                                <div className="flex gap-2.5">
                                    <button className="flex-[1] bg-[#18181b] hover:bg-[#27272a] text-white border border-gray-800 py-3 rounded-xl flex items-center justify-center gap-2 text-[13px] font-bold transition-all">
                                        <svg viewBox="0 0 24 24" width="16" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" /><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" /><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" /><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" /></svg>
                                        {t.preview_login}
                                    </button>
                                    <button className="flex-[1.5] bg-[#1a1500] hover:bg-[#2a2200] text-[#d97706] border border-[#d97706]/30 font-bold py-3 rounded-xl flex items-center justify-center text-[12px] transition-all">
                                        <Zap size={14} className="mr-1.5 fill-current" /> {t.preview_upgrade}
                                    </button>
                                </div>
                            </div>

                            <div className="text-center mt-6">
                                <span className="text-[#3f3f46] text-[11px] font-medium tracking-wide">{t.preview_version}</span>
                            </div>
                        </div>
                    </section>

                    {/* PROBLEM / AGITATION & FEATURES */}
                    <section id="features" className="bg-[#111113] py-24 border-y border-gray-800 relative overflow-hidden">
                        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-red-500/5 blur-[120px] rounded-full pointer-events-none"></div>

                        <div className="container mx-auto px-6 max-w-5xl text-center relative z-10">
                            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">{t.agitation_title}</h2>
                            <p className="text-lg text-gray-400 leading-relaxed mb-16 max-w-3xl mx-auto">
                                {t.agitation_desc}
                            </p>

                            <div className="grid md:grid-cols-3 gap-6 text-left">
                                <div className="p-8 bg-[#151518] rounded-[24px] border border-gray-800 hover:border-gray-700 transition-transform hover:-translate-y-1 duration-300">
                                    <div className="w-12 h-12 bg-blue-500/10 rounded-xl flex items-center justify-center mb-6">
                                        <Download className="text-blue-500" size={24} />
                                    </div>
                                    <h3 className="text-white font-bold text-xl mb-3">{t.feat1_title}</h3>
                                    <p className="text-gray-400 leading-relaxed">{t.feat1_desc}</p>
                                </div>

                                <div className="p-8 bg-[#151518] rounded-[24px] border border-gray-800 hover:border-gray-700 transition-transform hover:-translate-y-1 duration-300">
                                    <div className="w-12 h-12 bg-white/5 rounded-xl flex items-center justify-center mb-6">
                                        <img
                                            src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/Google_Drive_icon_%282020%29.svg/250px-Google_Drive_icon_%282020%29.svg.png"
                                            alt="Google Drive"
                                            className="w-7 h-7 object-contain"
                                        />
                                    </div>
                                    <h3 className="text-white font-bold text-xl mb-3">{t.feat2_title}</h3>
                                    <p className="text-gray-400 leading-relaxed">{t.feat2_desc}</p>
                                </div>

                                <div className="p-8 bg-gradient-to-br from-[#1a1500] to-[#151518] rounded-[24px] border border-yellow-600/30 transition-transform hover:-translate-y-1 duration-300">
                                    <div className="w-12 h-12 bg-yellow-500/10 rounded-xl flex items-center justify-center mb-6">
                                        <Zap className="text-yellow-500" size={24} />
                                    </div>
                                    <h3 className="text-yellow-500 font-bold text-xl mb-3">{t.feat3_title}</h3>
                                    <p className="text-gray-400 leading-relaxed">{t.feat3_desc}</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* PRICING */}
                    <section id="pricing" className="container mx-auto px-6 py-24 max-w-5xl">
                        <div className="text-center mb-16">
                            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">{t.pricing_title}</h2>
                            <p className="text-gray-400 text-lg">{t.pricing_desc}</p>
                        </div>

                        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
                            {/* FREE PLAN */}
                            <div className="p-10 rounded-[32px] bg-[#151518] border border-gray-800 flex flex-col hover:border-gray-600 transition-colors">
                                <div className="mb-8">
                                    <h3 className="text-2xl font-bold text-gray-300 mb-2">Free</h3>
                                    <div className="text-5xl font-black text-white">$0</div>
                                    <p className="text-gray-500 mt-3">{t.price_free_desc}</p>
                                </div>
                                <ul className="space-y-5 mb-10 flex-1">
                                    <li className="flex items-center gap-4 text-gray-300"><Check size={20} className="text-green-500" /> {t.price_free_1}</li>
                                    <li className="flex items-center gap-4 text-gray-300"><Check size={20} className="text-green-500" /> {t.price_free_2}</li>
                                    <li className="flex items-center gap-4 text-gray-300"><Check size={20} className="text-green-500" /> {t.price_free_3}</li>
                                    <li className="flex items-center gap-4 text-gray-300"><Check size={20} className="text-green-500" /> {t.price_free_4}</li>
                                </ul>
                                <button className="w-full py-4 rounded-xl bg-white/5 text-white font-bold border border-white/10 hover:bg-white/10 transition-colors flex items-center justify-center gap-2">
                                    <Chrome size={20} /> {t.btn_download}
                                </button>
                            </div>

                            {/* PRO PLAN */}
                            <div className="p-10 rounded-[32px] bg-gradient-to-b from-[#1a1500] to-[#0f0f11] border-2 border-[#d97706]/50 flex flex-col relative transform md:-translate-y-4 shadow-[0_20px_50px_rgba(217,119,6,0.15)] hover:border-[#d97706] transition-colors">
                                <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#d97706] text-black px-5 py-1.5 rounded-full text-xs font-black uppercase tracking-wider shadow-lg shadow-yellow-500/30">
                                    {t.price_pro_badge}
                                </div>
                                <div className="mb-8">
                                    <h3 className="text-2xl font-bold text-[#d97706] mb-2">{t.price_pro_title}</h3>
                                    <div className="flex items-end gap-1">
                                        <div className="text-5xl font-black text-white">$1</div>
                                        <div className="text-gray-400 mb-1.5">{t.price_pro_period}</div>
                                    </div>
                                    <p className="text-[#d97706]/70 mt-3">{t.price_pro_desc}</p>
                                </div>
                                <ul className="space-y-5 mb-10 flex-1">
                                    <li className="flex items-center gap-4 text-white"><Check size={20} className="text-[#d97706]" /> {t.price_pro_1}</li>
                                    <li className="flex items-center gap-4 text-white"><Check size={20} className="text-[#d97706]" /> {t.price_pro_2}</li>
                                    <li className="flex items-center gap-4 text-white"><Check size={20} className="text-[#d97706]" /> {t.price_pro_3}</li>
                                    <li className="flex items-center gap-4 text-white"><Check size={20} className="text-[#d97706]" /> {t.price_pro_4}</li>
                                </ul>
                                <button className="w-full py-4 rounded-xl bg-[#d97706] hover:bg-yellow-500 text-black font-black text-lg transition-colors shadow-[0_0_20px_rgba(217,119,6,0.4)]">
                                    {t.btn_unlock}
                                </button>
                            </div>
                        </div>
                    </section>
                </>
            )}

            {/* RENDERIZAÇÃO DAS PÁGINAS LEGAIS E SUCCESS */}
            {currentView === 'terms' && <LegalView title={t.terms_title} content={t.terms_content} />}
            {currentView === 'privacy' && <LegalView title={t.privacy_title} content={t.privacy_content} />}
            {currentView === 'success' && <SuccessView />}

            {/* FOOTER */}
            <footer className="border-t border-gray-800 bg-[#0a0a0c] py-12 mt-10">
                <div className="container mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-6">
                    <div className="flex flex-col items-center md:items-start gap-2">
                        <div className="flex items-center gap-2">
                            <div className="w-6 h-6 bg-[#8b1a1a] rounded-[6px] flex items-center justify-center">
                                <div className="w-2 h-2 bg-white rounded-full"></div>
                            </div>
                            <span className="font-bold text-gray-400">OneBuck Recorder</span>
                        </div>
                        <a href={`mailto:${t.footer_email}`} className="text-sm text-gray-600 hover:text-gray-400 transition-colors">
                            {t.footer_email}
                        </a>
                    </div>

                    <div className="text-sm text-gray-600 text-center">
                        © {new Date().getFullYear()} OneBuck. {t.footer_rights}
                    </div>

                    <div className="flex gap-6 text-sm text-gray-500 font-medium">
                        {/* Links reais para o Crawler do Google ler */}
                        <a
                            href="/terms"
                            className="hover:text-white transition-colors"
                        >
                            {t.footer_terms}
                        </a>
                        <a
                            href="/privacy"
                            className="hover:text-white transition-colors"
                        >
                            {t.footer_privacy}
                        </a>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default OneBuckLanding;